import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Redirect } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';
import { trackPageView } from './utils/analytics';

import LayoutSite from './layouts/LayoutSite';
import LayoutLanding from './layouts/LayoutLanding';
import Home from './views/Home';

const PrivacyPolicy = lazy(() => import('./views/PrivacyPolicy'));
const TermsOfUse = lazy(() => import('./views/TermsOfUse'));
const AccessibilityStatement = lazy(() => import('./views/AccessibilityStatement'));
const Nondiscrimination = lazy(() => import('./views/Nondiscrimination'));
const ServicesIndex = lazy(() => import('./views/services/ServicesIndex'));
const TechnologyStrategyReview = lazy(() => import('./views/services/TechnologyStrategyReview'));
const TechnologyAssessmentRoadmap = lazy(() => import('./views/services/TechnologyAssessmentRoadmap'));
const VcioAdvisory = lazy(() => import('./views/services/VcioAdvisory'));
const TwentyCrmImplementation = lazy(() => import('./views/services/TwentyCrmImplementation'));
const AiAutomation = lazy(() => import('./views/services/AiAutomation'));
const TwentyCrmCaseStudy = lazy(() => import('./views/case-studies/TwentyCrmCaseStudy'));
const RingCentral = lazy(() => import('./views/RingCentral'));

class App extends React.Component {

  componentDidMount() {
    document.body.classList.add('is-loaded')
    this.refs.scrollReveal.init();
    this.trackLocation();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
      this.refs.scrollReveal.init();
    }

    const pathChanged = this.props.location.pathname !== prevProps.location.pathname;
    const searchChanged = this.props.location.search !== prevProps.location.search;
    const hashChanged = this.props.location.hash !== prevProps.location.hash;
    if (pathChanged || searchChanged || hashChanged) {
      this.trackLocation();
    }

    const { hash } = this.props.location;
    if (hash && (hash !== prevProps.location.hash || this.props.location.pathname !== prevProps.location.pathname)) {
      const id = hash.replace(/^#/, '');
      const el = document.getElementById(id);
      if (el) {
        window.requestAnimationFrame(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  }

  trackLocation() {
    const { pathname, search, hash } = this.props.location;
    trackPageView(`${pathname}${search || ''}${hash || ''}`);
  }

  render() {
    return (
      <ScrollReveal
        ref="scrollReveal"
        children={() => (
          <Suspense fallback={null}>
            <Switch>
              <AppRoute exact path="/" component={Home} layout={LayoutLanding} />
              <AppRoute exact path="/services" component={ServicesIndex} layout={LayoutSite} />
              <AppRoute exact path="/services/technology-strategy-review" component={TechnologyStrategyReview} layout={LayoutSite} />
              <AppRoute exact path="/services/technology-assessment-roadmap" component={TechnologyAssessmentRoadmap} layout={LayoutSite} />
              <AppRoute exact path="/services/vcio-advisory" component={VcioAdvisory} layout={LayoutSite} />
              <AppRoute exact path="/services/twenty-crm-implementation" component={TwentyCrmImplementation} layout={LayoutSite} />
              <AppRoute exact path="/services/ai-automation" component={AiAutomation} layout={LayoutSite} />
              <AppRoute exact path="/case-studies/twenty-crm" component={TwentyCrmCaseStudy} layout={LayoutSite} />
              <AppRoute exact path="/privacy" component={PrivacyPolicy} layout={LayoutSite} />
              <AppRoute exact path="/terms" component={TermsOfUse} layout={LayoutSite} />
              <AppRoute exact path="/accessibility" component={AccessibilityStatement} layout={LayoutSite} />
              <AppRoute exact path="/nondiscrimination" component={Nondiscrimination} layout={LayoutSite} />
              <AppRoute exact path="/ringcentral" component={RingCentral} layout={LayoutLanding} />
              <Redirect to="/" />
            </Switch>
          </Suspense>
        )} />
    );
  }
}

export default withRouter(props => <App {...props} />);
